import TextWrapper from './TextWrapper';
import { type ReactNode, useMemo } from 'react';
import { GradualSpacing } from '../../../effects/GradualSpacing';

export default function MainText({ children, content, offset = 0 }: { children?: ReactNode, content: string, offset?: number }) {
    const fontSize = useMemo(() => {
        const maxWidth = content?.split('\n')?.reduce((a, b) => a.length > b.length ? a : b)?.length ?? 4;

        if (maxWidth > 13) {
            return '5.21vh'; // 100px
        }

        if (maxWidth > 8) {
            return '7.29vh'; // 140px
        }

        return '8.85vh'; // 170px
    }, [content]);

    return (
        <div
            style={{
                position: 'absolute',
                top: '18.23vh', // 350
                left: '2.6vh', // 50
                width: '49.48vh', // 950
                display: 'flex',
                flexDirection: 'column',
                gap: '1.04vh', // 20
            }}
        >
            <TextWrapper
                style={{
                    position: 'relative',
                    fontSize,
                    textTransform: 'uppercase',
                    textAlign: 'left',
                }}
            >
                <GradualSpacing
                    style={{
                        lineHeight: '0.8em',
                        letterSpacing: '-.04em',
                        textAlign: 'left',
                    }}
                    text={content}
                    offset={offset}
                />
            </TextWrapper>
            {children}
        </div>
    );
}
